import { useEffect } from 'react';
import { useActor } from '@xstate/react';

import { useHasLoggedOut } from '@order/AuthMachine';
import { useGlobalAppState } from '@order/GlobalAppState';

import { dietaryRestrictionsModel } from './dietaryRestrictionsMachine';

// ────────────────────────────────────────────────────────────────────────────────

export const useResetDietaryRestrictionsOnLogout = () => {
  const hasLoggedOut = useHasLoggedOut();

  // ─────────────────────────────────────────────────────────────────

  const { dietaryRestrictionsMachineRef } = useGlobalAppState();
  const [, send] = useActor(dietaryRestrictionsMachineRef);

  // ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!hasLoggedOut) return;

    send(dietaryRestrictionsModel.events.CLEAR_RESTRICTIONS());
  }, [hasLoggedOut, send]);
};
